module.exports = __webpack_public_path__ + "static/media/hero.5029d049.svg";